// WithHideMessage.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import trackMixpanel, {
  getViewId,
  ButtonId,
  EventTypes,
} from '../resource/mixpanel.js';

import DeleteIconResource from '../../img/ic-delete-outline.svg';

export const WithHideMessage = ({
  messageId = null,
  meId = null,
  senderId = null,
  mixpanelModalId = null,
  isHideMessageEnabled = false,
  isHidePermissionMatched = false,
  toggleModal = () => null,
  children = () => null,
}) => {
  const isAuthor = meId && meId === senderId;
  const handleOnClick = useCallback(() => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({ pathname: window.location.pathname }),
        buttonId: ButtonId.All.ButtonHiddenMassage,
        modalId: mixpanelModalId,
        extraProps: {
          'message.id': messageId,
        },
      },
    });
    return toggleModal({
      modalId: 'HideMessageConfirmModal',
      payload: {
        messageId,
        modalType: 'hide-message-confirm-modal',
      },
      isOpen: true,
    });
  }, [messageId, mixpanelModalId, toggleModal]);
  const canHideMessage =
    isHideMessageEnabled && (isHidePermissionMatched || isAuthor);
  if (!messageId || !canHideMessage) return null;
  return children({
    handleOnClick,
    iconSource: DeleteIconResource,
  });
};

WithHideMessage.propTypes = {
  messageId: PropTypes.string,
  meId: PropTypes.string,
  senderId: PropTypes.string,
  mixpanelModalId: PropTypes.string,
  isHideMessageEnabled: PropTypes.bool,
  isHidePermissionMatched: PropTypes.bool,
  children: PropTypes.func,
  toggleModal: PropTypes.func,
};

export default WithHideMessage;
